import { useState, useEffect, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const handleScroll = useCallback(() => {
    setScrolled(window.scrollY > 60);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/all', label: '分类' },
    { to: '/about', label: '关于我们' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 group"
            aria-label="43423漫画网首页"
          >
            <div className="w-9 h-9 flex items-center justify-center">
              <i className="ri-book-read-line text-2xl text-primary-500"></i>
            </div>
            <span
              className={`font-heading text-xl font-bold transition-colors ${
                scrolled ? 'text-foreground-950' : 'text-white'
              }`}
            >
              43423漫画网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                  location.pathname === link.to ||
                  (link.to === '/' && location.pathname === '/') ||
                  (link.to === '/category/all' &&
                    location.pathname.startsWith('/category'))
                    ? scrolled
                      ? 'bg-primary-100 text-primary-700'
                      : 'bg-white/20 text-white'
                    : scrolled
                      ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50'
                      : 'text-white/80 hover:text-white hover:bg-white/10'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="flex items-center gap-3">
            <div className="hidden md:flex items-center gap-2">
              <button className="w-9 h-9 flex items-center justify-center rounded-lg transition-colors cursor-pointer whitespace-nowrap" aria-label="搜索">
                <i
                  className={`ri-search-line text-lg ${
                    scrolled ? 'text-foreground-600 hover:text-primary-500' : 'text-white/80 hover:text-white'
                  }`}
                ></i>
              </button>
              <Link
                to="/about"
                className="px-4 py-2 bg-primary-500 text-white text-sm font-medium rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                联系客服
              </Link>
            </div>

            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className="md:hidden w-9 h-9 flex items-center justify-center cursor-pointer whitespace-nowrap"
              aria-label="菜单"
            >
              <i
                className={`text-xl ${
                  scrolled ? 'text-foreground-800' : 'text-white'
                } ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}
              ></i>
            </button>
          </div>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-primary-50 hover:text-primary-600 transition-colors whitespace-nowrap"
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/about"
              className="mt-2 px-4 py-3 bg-primary-500 text-white text-sm font-medium rounded-lg text-center hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              联系客服
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}